//#region Styles
import { 
    Container, Content } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import SearchDialogAlert from "./components/SearchDialogAlert/SearchDialogAlert";
import FoundField from "./components/FoundField/FoundField";
import InputButtonText from "./components/InputButtonText/InputButtonText";
import { Column, HelperText } from "components/styles";
//#endregion

const SearchInDialogAlert = ({
    widthFoundField,
    label, direction, helperText, 
    placeholder, buttonProps, 
    inputButtonTextProps, 
    changeSearchField, minLength,
    data, fillData,
    clearData, getDataItemText,
    loadingSearch = false, 
    mostSimilar, titleDialog, 
    showDialogAlert, toggleDialogAlert, 
    firstSelection, name, 
    notFoundMessage, notFoundSubmessage
}) => {
    return (
        <>
        <Container direction={direction}>
            <Content>
                {inputButtonTextProps && (
                    <InputButtonText 
                        {...inputButtonTextProps}
                        onClick={() => toggleDialogAlert(true)}/>
                )}
                {buttonProps && 
                    (firstSelection 
                        ? <FoundField 
                            width={widthFoundField}
                            label={label}
                            text={name}
                            error={buttonProps.error}
                            errorText={buttonProps.errorText}
                            showDialog={toggleDialogAlert}
                            helperText={helperText}
                            button={{
                                text: "Cambiar",
                                onClick: () => toggleDialogAlert(true)
                            }}/> 
                        : buttonProps && 
                            <Column gap="5px">
                                <label>{label}</label>
                                <>
                                <CustomButton 
                                    {...buttonProps}
                                    width="250px"
                                    onClick={() => toggleDialogAlert(true)}/>
                                {helperText && <HelperText>{helperText}</HelperText>}
                                </>
                            </Column>
                )}
            </Content>
        </Container>
        <SearchDialogAlert 
            title={titleDialog}
            placeholder={placeholder}
            show={showDialogAlert}
            toggleShow={toggleDialogAlert}
            changeSearchField={changeSearchField}
            data={data}
            fillData={fillData}
            clearData={clearData}
            minLength={minLength}
            getDataItemText={getDataItemText}
            loadingSearch={loadingSearch}
            mostSimilar={mostSimilar}
            notFoundMessage={notFoundMessage}
            notFoundSubmessage={notFoundSubmessage}/>
        </>
    );
}

export default SearchInDialogAlert;